import {http} from './config/config-relation-register'

export default{
    listar:async(token)=>{
        return  http.get('tipos-aplicacao',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('tipos-aplicacao',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('tipos-aplicacao/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('tipos-aplicacao/'+item.id_tipo_aplicacao,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}